import { Text } from '@shared/components';
import { CloseButton } from './CloseButton';

export const RedactedQuote = ({
  id,
  onClose,
}: {
  onClose: () => void;
  id: string;
}) => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <div className="flex flex-row justify-end">
        <CloseButton onPress={onClose} variant="secondary" />
      </div>
      <Text type="body-sm" className="text-gray-500">
        Quote {id} has been redacted due to your organization&apos;s data
        retention policy.
      </Text>
    </div>
  );
};
